import { useEffect, useState } from 'react';

interface UseCountdownProps {
  initialSeconds: number;
  onCountdown?: (remainingSeconds: number) => void;
  onCountdownFinish?: () => void;
}

export default function useCountdown({
  initialSeconds,
  onCountdown,
  onCountdownFinish,
}: UseCountdownProps) {
  const [remainingSeconds, setRemainingSeconds] = useState<number>(initialSeconds);
  useEffect(() => {
    setRemainingSeconds(initialSeconds);
  }, [initialSeconds]);

  useEffect(() => {
    let intervalId: number;
    if (onCountdown) onCountdown(remainingSeconds);

    if (remainingSeconds > 0) {
      intervalId = window.setTimeout(() => {
        setRemainingSeconds(remainingSeconds - 1);
      }, 1000);
    } else if (onCountdownFinish) {
      intervalId = window.setTimeout(() => {
        onCountdownFinish();
      }, 1000);
    }

    return () => clearTimeout(intervalId);
  }, [remainingSeconds, onCountdown, onCountdownFinish]);

  return { remainingSeconds, isTimeout: remainingSeconds <= 0 };
}
